<template>
  <div class="shop-order-info">
    <div class="order-state-container order-wrapper store-order">
      <div class="order-state" v-if="orderState > -1">
        <span>{{ orderStateOptions[orderState].label }}</span>&nbsp;
        <span>{{ orderStateOptions[orderState].labelEn }}</span>
      </div>
      <div class="refund_price" v-if="orderState==4">
        <span>已退 Refunded ￥{{orderInfo.refundAmount}}</span>
      </div>
    </div>
    <div class="order-no-content primary-text">订单编号 Order number：{{ orderNo }}</div>

    <div class="location-detail">
      <div class="location-title">
        联系人信息 Contact Information
      </div>
      <div class="order-location-content primary-text">
        <div class="order-location-item">联系人 Contact person：{{ orderInfo.buyerName }}</div>
        <div class="order-location-item">手机号 Telephone：{{ orderInfo.buyerMobile }}</div>
        <div class="order-location-item">
          订单备注 Order memo：{{ orderInfo.summary == null ? "--" : orderInfo.summary }}
        </div>
      </div>
    </div>

    <div class="pay-info">
      <div class="location-detail">
        <div class="location-title">
          支付信息 Payment Information
        </div>
        <div class="order-location-content primary-text">
          <div class="order-location-item" v-for="(item, index) in paymentInformation.slice(0, 2)" :key="index">
            {{ item.chName }} {{ item.enName }}：{{ item.val }}
          </div>
        </div>
        <div class="order-location-content primary-text">
          <div class="order-location-item" v-for="(item, index) in paymentInformation.slice(2)" :key="index">
            {{ item.chName }} {{ item.enName }}：{{ item.val }}
          </div>
        </div>
      </div>
    </div>

    <div class="location-detail">
      <div class="location-title">
        价格明细 Price breakdown
      </div>
      <div class="order-location-content primary-text">
        <div class="order-price-item" v-for="(item, index) in priceList" :key="index">
          <div class="hotel-item-left">
            <span>{{ item.goodsDate }}</span>
            <span>{{ item.specName }}</span>
          </div>
          <div class="hotel-item-right">
            <span>{{ item.qty }}×</span>
            <span>￥{{ item.price }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="order-dis-wrapper">
      <div class="order-dis-wrapper-inner">
        <div class="detailed-item primary-text" v-for="(item, index) in detailedT" :key="index">
          <div class="detailed-item-l">
            <span>{{ item.chName }}</span
            >&nbsp;
            <span>{{ item.enName }}</span>
          </div>
          <div class="detailed-item-r">
            <span v-if="item.hasSymbol">￥</span>
            <span>{{ item.val }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="order-btns">
      <template v-for="(btn, index) in btns">
        <div
            @click="handleClick(btn.funName)"
            :class="['btn-item', btn.btnType == 'normal' ? 'normal-btn' : 'primary-btn']"
            :key="index"
        >
          <div>
            <p>{{ btn.chName }}</p>
            <p>{{ btn.enName }}</p>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      orderState: -1, //0待付款 1待受理 2待入住 3已完成 4已退款 5已取消
      orderStateOptions: {},
      isZiti: true,
      paymentInformation: [],
      orderInfo: {},
      showPaymentDetails: false, //是否展示价格明细弹窗
      takeType: "", //提货方式 1 物流 2 自提 3 物流 + 自提
      detailList: [], //提货码
      priceList: [],
      btns: [],
      detailedT: [],
    };
  },
  props: {},
  computed: {
    orderNo() {
      return this.$route.query.orderNo;
    },
  },
  components: {},
  mounted() {
    this.orderStateOptions = this.$_.cloneDeep(this.$optionsData.orderHotelStateOptions);
    this.getHotelOrderDetail();
  },
  methods: {
    //查看订单详情
    async getHotelOrderDetail() {
      const params = {
        orderNo: this.orderNo,
      };
      try {
        let {data} = await this.$api.getHotelOrderDetail(params);
        let {
          payChannel,
          tradeNo,
          orderTime,
          payTime,
          copeAmount,
          goodsDecrAmount,
          platformDecrAmount,
          payAmount,
          bonusDecrAmount,
          hotelOrderStatus: orderState,
          channelCode,
        } = data.orderVO;
        const payWay = this.$utils.getPayWay(data.status, payChannel, payTime)
        this.paymentInformation = [
          {
            chName: "支付方式",
            enName: "Pay way",
            val: payWay,
            hasSymbol: false,
            colored: false,
            hidden: payChannel == null ? true : false,
          },
          {
            chName: "交易流水号",
            enName: "Trading serial number",
            val: tradeNo,
            hasSymbol: false,
            colored: false,
            hidden: tradeNo == null ? true : false,
          },
          {
            chName: "渠道码",
            enName: "Channel Code",
            val: channelCode,
            hasSymbol: false,
            colored: false,
            hidden: channelCode == null ? true : false,
          },
          {
            chName: "下单时间",
            enName: "Order time",
            val: orderTime,
            hasSymbol: false,
            colored: false,
          },
          {
            chName: "支付时间",
            enName: "Payment time",
            val: payTime,
            hasSymbol: false,
            colored: false,
            hidden: payTime == null ? true : false,
          },
        ].filter((v) => !v.hidden);

        let detailedT = [
          {
            chName: "商品总价",
            enName: "Total price of goods",
            val: copeAmount,
            hasSymbol: true,
          },
          {
            chName: "商品优惠",
            enName: "Merchandise discount",
            val: goodsDecrAmount,
            hasSymbol: true,
          },
          {
            chName: "平台优惠",
            enName: "Platform offers",
            val: platformDecrAmount,
            hasSymbol: true,
          },
          {
            chName: "订单总价",
            enName: "Total order price",
            val: payAmount,
            hasSymbol: true,
          },
          {
            chName: "奖励金",
            enName: "Bonus",
            val: bonusDecrAmount,
            hasSymbol: true,
          },
          {
            chName: this.$utils.getPayAmount(orderState,payTime).label,
            enName: this.$utils.getPayAmount(orderState,payTime).labelEn,
            val: payAmount,
            hasSymbol: true,
            colored: true,
          },
        ];

        let detailedM = [
          {
            chName: "奖励金",
            enName: "Bonus",
            val: bonusDecrAmount,
            hasSymbol: true,
          },
          {
            chName: "实付",
            enName: "Actual payment",
            val: payAmount,
            hasSymbol: true,
            colored: true,
          },
        ];
        this.orderState = orderState;
        this.orderInfo = data.orderVO;
        this.priceList = data.list;
        this.detailedT = detailedT;
        this.detailedM = detailedM;
        this.btns = this.orderStateOptions[orderState].btns;
      } catch (error) {
        console.log(error);
      }
    },
    //订单按钮点击事件
    handleClick(funName) {
      this[funName](this.orderInfo);
    },
    //取消订单
    cancelOrder(info) {
      this.$confirm("确定取消该订单？", "提示", {
        type: "warning",
        cancelButtonText: "再想想",
        confirmButtonText: "确定取消",
      })
          .then(async () => {
            try {
              await this.$api.cancelHotelOrder({
                orderNo: info.orderNo,
              });
              this.$message.success("取消成功");
              this.getHotelOrderDetail();
            } catch (error) {
              console.log(error);
            }
          })
          .catch(() => {
          });
    },
    //去付款
    payGoods(info) {
      this.$router.push(`/home/pay-way?orderNo=${info.orderNo}&orderType=h`);
    },
  },
};
</script>

<style lang="scss" scoped>
.shop-order-info {
  padding: 10px;
  box-sizing: border-box;
  box-sizing: border-box;

  .order-state-container {
    padding: 30px;
    background: #fcfcfc;
    margin-top: 30px;

    .order-state {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }

    .order-state-group {
      margin-top: 20px;
    }
  }

  .order-no-content {
    margin-top: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid #f0f0f0;
  }

  .location-title {
    margin-top: 30px;
    font-size: 18px;
    font-weight: bold;
    color: #333333;
  }

  .order-location-content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 28px;

    .order-location-item {
      margin-left: 99px;
      margin-bottom: 20px;
      flex: none;

      &:first-child {
        margin-left: 0;
      }
    }
  }

  .location-detail {
    padding-bottom: 28px;
    border-bottom: 1px solid #f0f0f0;
  }

  .order-dis-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 60px;

    .order-dis-wrapper-inner {
      text-align: right;

      .detailed-item {
        display: flex;
        align-items: center;
        width: 600px;
        justify-content: space-between;
        margin-bottom: 30px;

        .detailed-item-l {
          text-align: right;
          width: 500px;
        }

        .detailed-item-r {
          margin-left: auto;
        }
      }
    }
  }

  .order-btns {
    margin-top: 40px;
    display: flex;
    align-items: center;
  }

  .btn-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 144px;
    height: 40px;
    cursor: pointer;
    margin-top: 2px;

    div {
      font-size: 14px;
      font-weight: 400;
      text-align: center;
    }

    &.normal-btn {
      background: #fff;
      color: #333333;
    }

    &.primary-btn {
      background: #333333;
      color: #ffffff;
    }
  }

  .order-price-item {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-right: 70px;

    .hotel-item-left {
      margin-right: 55px;
    }
  }
}
.refund_price{
  font-size: 13px;
  font-weight: 500;
  color: #999999;
  line-height: 20px;
  margin-top: 10px;
}
</style>
